import { FC } from "react";
import "../css/chatbot.css";

interface ThemeToggleProps {
  theme: string;
  setTheme: React.Dispatch<React.SetStateAction<string>>;
}

const ThemeToggle: FC<ThemeToggleProps> = ({ theme, setTheme }) => {
  return (
    <button 
      className="btn theme-toggle-button"
      onClick={() => setTheme(theme === "light" ? "dark" : "light")}
    >
      {theme === "light" ? (
        <i className="bi bi-moon" />
      ) : (
        <i className="bi bi-brightness-high" />
      )}
    </button>
  );
};

export default ThemeToggle;
